import type { IAuthRepository } from '../repositories/IAuthRepository.js';
import type { AuthSessionEntity } from '../entities/AuthSessionEntity.js';

interface Dependencies {
  authRepository: IAuthRepository;
}

export function createRefreshSessionUseCase({ authRepository }: Dependencies) {
  return async function refreshSession(): Promise<AuthSessionEntity | null> {
    return authRepository.refreshSession();
  };
}
